export const addEnterButtonListener = (callback: () => void) => {
  const listener = (event: KeyboardEvent) => {
    if (event.code !== "Enter" && event.code !== "NumpadEnter") return;
    event.preventDefault();
    callback();
  };

  document.addEventListener("keydown", listener);
  return () => {
    document.removeEventListener("keydown", listener);
  };
};
